import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { Button, FinancieraLogo, OfertaCardData } from "@components/ui_v2";

const NOTA_TEXT = "#5C6B7C";
const DIALOG_SCRIM = "rgba(6, 44, 78, 0.55)";

interface Props {
  oferta: OfertaCardData;
  disabled: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirmación para sacar una preoferta de la comparativa. */
export const DialogDescartarOferta = ({ oferta, disabled, onConfirm, onClose }: Props) => (
  <Dialog
    open
    onClose={onClose}
    fullWidth
    PaperProps={{ sx: { maxWidth: 440, borderRadius: "18px", boxShadow: "0 24px 64px rgba(6, 44, 78, 0.35)" } }}
    slotProps={{ backdrop: { sx: { bgcolor: DIALOG_SCRIM, backdropFilter: "blur(4px)" } } }}
  >
    <DialogContent sx={{ p: "30px 28px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 40,
          mb: "18px",
          filter: "grayscale(1)",
          opacity: 0.75,
        }}
      >
        <FinancieraLogo logo={oferta.logo} financiera={oferta.financiera} maxHeight={40} maxWidth="70%" />
      </Box>

      <Typography sx={{ fontWeight: 600, fontSize: 20, color: "primary.dark", textAlign: "center", mb: "10px" }}>
        ¿Descartar esta preoferta?
      </Typography>
      <Typography
        sx={{
          fontSize: 14.5,
          lineHeight: 1.55,
          color: NOTA_TEXT,
          textAlign: "center",
          mb: "24px",
          "& strong": { color: "primary.dark" },
        }}
      >
        Confirmarás que no te interesa la preoferta de <strong>{oferta.financiera}</strong> y se eliminará de tu
        comparativa. <strong>Esta acción no es reversible.</strong> Las demás preofertas seguirán disponibles.
      </Typography>

      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Button
          tone="outline"
          fullWidth
          disabled={disabled}
          onClick={onClose}
          data-testid="ofertas-descartar-dialog-cancel-button"
        >
          Cancelar
        </Button>
        <Button
          tone="dark"
          fullWidth
          disabled={disabled}
          onClick={onConfirm}
          data-testid="ofertas-descartar-dialog-confirm-button"
        >
          Sí, descartar
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);
